export default __webpack_public_path__ + "psn-frame.8e7c9e6990999a53979a28aa4f649b28.css";